import { render } from "./StaticView.vue?vue&type=template&id=ec1e8ef2"
import script from "./StaticView.vue?vue&type=script&lang=js"
export * from "./StaticView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__